import cn from 'classnames';

import {CARD_TEXT_COLOR_CLASSNAME} from '@/root/constants/cardTextColors';
import {HeadlineTemplateProps} from '@/root/models/card';

const HeadlineBTemplate = ({
  isThumbnail,
  title,
  subTitle,
  backgroundImageUrl,
  textColor,
  onClickDetail,
  isActive
}: HeadlineTemplateProps) => {
  const textColorClassName = CARD_TEXT_COLOR_CLASSNAME[textColor];

  return (
    <div
      className={cn('item_card item_type2', textColorClassName, isActive && 'active')}
      style={{backgroundImage: `url(${backgroundImageUrl})`}}
    >
      <div className="inner_card">
        <span className="txt_desc">{subTitle.value}</span>
        <div className="head_card">
          <strong className="tit_card" role="text">
            {title.value}
          </strong>
        </div>
      </div>
      {!isThumbnail && (
        <button type="button" className="btn_view" onClick={onClickDetail}>
          <span className="screen_out">카드 상세 보기</span>
        </button>
      )}
    </div>
  );
};
export default HeadlineBTemplate;
